import { supabase } from "@/lib/supabase";

export interface OrganizationContextNotification {
  deliveryId: string;
  title: string;
  organization: string;
  uploader: string;
  reasonCategory: string;
  uploadTime: string;
  actionPath: string;
  readAt: string | null;
}

export async function getOrganizationContextNotifications(): Promise<OrganizationContextNotification[]> {
  const { data, error } = await supabase.rpc("list_organization_context_notifications");
  if (error) throw error;
  return (data ?? []).map((item) => ({
    deliveryId: item.delivery_id,
    title: item.title,
    organization: item.organization,
    uploader: item.uploader,
    reasonCategory: item.reason_category,
    uploadTime: item.upload_time,
    actionPath: item.action_path,
    readAt: item.read_at,
  }));
}

export async function markOrganizationContextNotificationRead(deliveryId: string): Promise<void> {
  const { error } = await supabase.rpc("mark_organization_context_notification_read", { _delivery_id: deliveryId });
  if (error) throw error;
}

export async function markAllOrganizationContextNotificationsRead(): Promise<void> {
  const { error } = await supabase.rpc("mark_all_organization_context_notifications_read");
  if (error) throw error;
}
